import React from 'react'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ReactNotificationComponent = ({title,body}) => {
    toast.info(<Display />);
    function Display(){
        return (
            <div>
                <p>{title}</p>
                {/* <p>{body}</p> */}
            </div>
        );
    }
  return (
   <ToastContainer />
  );
}

export default ReactNotificationComponent